<template lang="html">
  <div class="edit-user">
    <Overlay width="small" :link="{name: 'users'}">
      <user-form
        v-model="user"
        @submit="submitUser"
        :companies="companyOptions"
        :availablePermissions="availablePermissions"
        :errors="errors"
      />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'

import {mapState} from 'vuex'

import {readUserData, updateUserData} from '@/lib/users'
import {readCompaniesData} from '@/lib/companies'

import Overlay from '@/components/Overlay'
import UserForm from '@/components/forms/UserForm'

export default {
  name: 'EditUser',

  mixins: [page],

  components: {
    Overlay,
    UserForm
  },

  props: {
    userId: String
  },

  data() {
    return {
      uuser: {permissions: {}},
      errors: {},
      companies: []
    }
  },

  computed: {
    ...mapState(['currentUser']),

    availablePermissions() {
      return this.currentUser.permissions
    },

    companyOptions() {
      return this.companies.map((company) => {
        return {key: company.name, value: company.id}
      })
    },

    title() {
      return `Editing ${this.user.email}`
    },

    user: {
      get() {
        // set empty array for each available permission relm so that vue
        // witchcraft kicks in and we can populate permission relm actions via
        // checkboxes.
        let user = this.uuser

        Object.keys(this.availablePermissions).forEach((relm) => {
          if (!user.permissions[relm]) {
            user.permissions[relm] = []
          }
        })

        return user
      },

      set(value) {
        this.uuser = value
      }
    }
  },

  methods: {
    submitUser() {
      updateUserData(this.userId, this.user).then(({data}) => {
        this.$router.push({name: 'user', params: {userId: data.id}})
      })
    },

    getData() {
      readCompaniesData({page_size: 1000}).then(({data}) => {
        this.companies = data
      })

      readUserData(this.userId).then(({data}) => {
        this.uuser = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
